<template>
  <div style="pointer-events:none;">
  <v-layout style="position:fixed;top:0px;bottom:10px;left:0px;right:0px;">
    <v-row  style="width:100%;" :align="($vuetify.breakpoint.smAndDown) ? 'end' : 'center'" justify="center"  v-if="activeTour != null" class="pa-3 ma-0">
      <v-col cols="auto" class="pa-0 ma-0">
        <v-btn class="ma-0" style="pointer-events:auto;" :small="$vuetify.breakpoint.smAndDown" :x-large="!$vuetify.breakpoint.smAndDown"  dark color="rgba(0,0,0,0.6)" :disabled="activeTourIndex == 0" @click="OnTapPrevTourPoint()">
          <v-icon left x-large color="#ff00ff">
            mdi-chevron-left
          </v-icon>
          PREVIOUS STOP
        </v-btn>
      </v-col>
      <v-spacer/>
      <v-col cols="auto" class="pa-0 ma-0">
        <v-btn class="ma-0" style="pointer-events:auto;" :small="$vuetify.breakpoint.smAndDown" :x-large="!$vuetify.breakpoint.smAndDown"  dark color="rgba(0,0,0,0.6)" @click="(activeTourIndex == activeTour.tourPoints.length - 1) ?  CloseTour() : OnTapNextTourPoint()">
          {{(activeTourIndex == activeTour.tourPoints.length - 1) ? 'END TOUR' : 'NEXT STOP'}}
           <v-icon right x-large color="#ff00ff">
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </v-col>
      <v-col>
      </v-col>
    </v-row>
  </v-layout>
  <v-layout style="position:fixed;top:0px;bottom:10px;left:0px;right:0px;" v-if="waypoint != null && waypoint.otherSideWaypoint != null && waypoint.otherSideWaypoint != ''">
    <v-row align="end" justify="center" v-if="showOtherSideOption">
      <v-col cols="auto">
        <v-btn color="pink" @click="GoTOOtherSide" style="pointer-events:auto;" dark>
        Other Side
        </v-btn>
      </v-col>
    </v-row>
  </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapMutations,mapState, mapActions } from 'vuex'
export default {
  name: 'SphereNavigator',
  components: {
  },
  props: {
    isActive : false,
    babylonPanelIdentifier : "",
    waypoint : null,
    waypoints : Array,
    waypointNavigation : false,
    navigationType : "",
    targetTouchpoint : null
  },
  computed: {
    ...mapState("sessionState", [
      "forceLandRotation",
      "activeTour",
      "activeTourIndex",
      "package",
      "videoGroups"
    ]),
    ...mapGetters("sessionState", [
        "GetBabPnl",
        "CurrentStageData"
    ]),
  },

  mounted: () => {

  },
  data: () => ({

    processedWaypoints : null,
    isInitalized : false,
    currentWaypoint : null,
    firstWaypointLoad : true,
    waypointVisibilityDistance : 100,
    isLoading : false,
    forceLookDir : false,
    showOtherSideOption : false
  }),
  methods: {

    ...mapMutations("sessionState", [
      "SetForceLandRotation",
      "GoNextTourPoint",
      "GoPrevTourPoint",
      "CloseTour",
      "SetVideoGroupsToPlay"
    ]),
    Init()
    {
      this.CreateCamera();
      this.CreateSphere();
      this.ProcessWaypoints();
    },
    GoTOOtherSide()
    {
      this.forceLookDir = true;
      this.currentWaypoint = this.waypoints.find(waypoint => waypoint.id == this.waypoint.otherSideWaypoint);
    },
    CreateCamera()
    {
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);
      var camera;
      camera = new BABYLON.FreeCamera("UniversalCamera", new BABYLON.Vector3(0, 0, 0), inst.scene);
      camera.fov = 1.2;
      camera.lowerRadiusLimit = 0.001;
      camera.upperRadiusLimit = 0.001;
      camera.allowUpsideDown = false;
      camera.minZ = 0.01;
      camera.inputs.attached.mouse.angularSensibility = camera.inputs.attached.mouse.angularSensibility * -2
      camera.interia = 0.2;
      camera.inputs.attached.keyboard.detachControl();
      var inputManager = camera.inputs;
      camera.attachControl(inst.canvas, true);
      this.$options.camera = camera;
      camera.inputs.attached.keyboard.detachControl();
      this.$options.camera = camera;
      this.$options.mainUi = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI",true);
      

      inst.scene.registerBeforeRender(() => {

        if(!this.isLoading && this.currentWaypoint != null)
        {
          
          if (camera.rotation.x < -0.6) {
            camera.rotation.x = -0.6;
          }
          if (camera.rotation.x > 0.6) {
            camera.rotation.x = 0.6;
          }
          

          if(this.currentWaypoint.locked == true)
          {
            let anchorRadians = BABYLON.Tools.ToRadians(this.currentWaypoint.euler.y);
            let angleDistance = this.$options.camera.rotation.y - anchorRadians;
            if(Math.abs(angleDistance) > 1.5)
            {
              if(angleDistance > 0)
              {
                camera.rotation.y = anchorRadians + 1.5;
              }
              else
              {
                camera.rotation.y = anchorRadians - 1.5;
              }
            }
          }

          if(this.currentWaypoint != null)
          {
            if(this.currentWaypoint.otherSideWaypoint != null && this.currentWaypoint.otherSideWaypoint != '')
            {
              var camDir = inst.scene.activeCamera.getForwardRay().direction;
              let forwardDir = new BABYLON.Vector3(this.currentWaypoint.forwardX, this.currentWaypoint.forwardY,this.currentWaypoint.forwardZ);
              let dot = BABYLON.Vector3.Dot(forwardDir,camDir);

              if(dot > 0.7)
              {
                this.showOtherSideOption = true;
              }
              else
              {
                this.showOtherSideOption = false;
              }
            }
          }
        }

        
      })

    },
    CreateSphere()
    {
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);
      // The first parameter can be set to null to load all meshes and skeletons
      BABYLON.SceneLoader.ImportMesh("", "https://xpcwa.blob.core.windows.net/assets/Models/", "HalfSphereV3.glb", inst.scene, (meshes, particleSystems, skeletons) => {
          meshes[0].scaling = new BABYLON.Vector3(-100, -100, 100);
          this.$options.sphere = meshes[0];
          this.$options.leftSphere = meshes[2];
          this.$options.rightSphere = meshes[1];

          var leftmat = new BABYLON.StandardMaterial('leftSphereMaterial', inst.scene);
          leftmat.backFaceCulling = false;
          leftmat.disableLighting = true;
          this.$options.leftSphere.material = leftmat;
          this.$options.leftSphere.isPickable = false;

          var rightMat = new BABYLON.StandardMaterial('rightSphereMaterial', inst.scene);
          rightMat.backFaceCulling = false;
          rightMat.disableLighting = true;
          this.$options.rightSphere.material = rightMat;
          this.$options.rightSphere.isPickable = false;

          this.isInitalized = true;
          this.$emit("initalized");
      });
    },
    LoadWaypoint()
    {
      this.isLoading = true;
      this.$emit("LoadingWaypoint",this.currentWaypoint);
      setTimeout(() => { 
        if(this.$options.leftSphere.material.emissiveTexture != null)
        {
          this.$options.leftSphere.material.emissiveTexture.dispose();
          this.$options.leftSphere.material.emissiveTexture = null;
        }
        
        if(this.$options.rightSphere.material.emissiveTexture != null)
        {
          this.$options.rightSphere.material.emissiveTexture.dispose();
          this.$options.rightSphere.material.emissiveTexture = null;
        }
          
        var inst = this.GetBabPnl(this.babylonPanelIdentifier);
        
        var assetsManager = new BABYLON.AssetsManager(inst.scene);
        assetsManager.useDefaultLoadingScreen = false;

        var leftTexture = null;
        var rightTexture = null;

        var leftTextureTask = assetsManager.addTextureTask("LeftSphereTask", this.currentWaypoint.leftImgUrl);
        leftTextureTask.onSuccess = (task) => {
          leftTexture = task.texture;
          leftTexture.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE;
        }

        var rightTextureTask = assetsManager.addTextureTask("RightSphereTask", this.currentWaypoint.rightImgUrl);
        rightTextureTask.onSuccess = (task) => {
          rightTexture = task.texture;
          rightTexture.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE;
        }

      
        assetsManager.load();
        assetsManager.onFinish = (tasks) => {
          
          this.isLoading = false;
          if(this.firstWaypointLoad)
          {
            this.$options.camera.rotation = new BABYLON.Vector3(BABYLON.Tools.ToRadians(this.currentWaypoint.euler.x),BABYLON.Tools.ToRadians(this.currentWaypoint.euler.y),0);
            this.firstWaypointLoad = false;
            this.currentWaypoint.isFirst = true;
          }

          if(this.forceLookDir)
          {
            this.$options.camera.rotation = new BABYLON.Vector3(BABYLON.Tools.ToRadians(this.currentWaypoint.euler.x),BABYLON.Tools.ToRadians(this.currentWaypoint.euler.y),0);
            this.forceLookDir = false;
          }

        

          this.$options.leftSphere.material.emissiveTexture = leftTexture;
          this.$options.rightSphere.material.emissiveTexture = rightTexture;
          this.UpdateCameraForWaypoint(this.currentWaypoint);
          
          this.UpdateFloorMarkers();
          this.$emit("WaypointLoaded",this.currentWaypoint);

        };
      },150)
    },
    UpdateCameraForWaypoint(newWaypoint)
    {
      this.$options.camera.position = new BABYLON.Vector3(newWaypoint.pos.x,newWaypoint.pos.y,newWaypoint.pos.z);
      this.$options.sphere.position = new BABYLON.Vector3(newWaypoint.pos.x,newWaypoint.pos.y,newWaypoint.pos.z);

      if(newWaypoint.locked == true)
      {
        let anchorRadians = BABYLON.Tools.ToRadians(newWaypoint.euler.y);
        let angleDistance = this.$options.camera.rotation.y - anchorRadians;
        if(Math.abs(angleDistance) > 1.5)
        {
          this.$options.camera.rotation = new BABYLON.Vector3(BABYLON.Tools.ToRadians(newWaypoint.euler.x),BABYLON.Tools.ToRadians(newWaypoint.euler.y),0);
        }
      }

        if(this.forceLandRotation && this.targetTouchpoint != null)
        {
          let facePosition = new BABYLON.Vector3(this.targetTouchpoint.pos.x,this.targetTouchpoint.pos.y,this.targetTouchpoint.pos.z);
          let targety = (this.targetTouchpoint.pos.y < this.$options.camera.position.y) ? this.$options.camera.position.y : this.targetTouchpoint.pos.y + 0.05;

          facePosition.y = targety;
          //Rotate to face touchpoint
          //let dstY = (this.$options.camera.position.y > this.targetTouchpoint.position.y) ? this.$options.camera.position.y : this.targetTouchpoint.y;
          // dstY += 0.1;
          this.$options.camera.setTarget(facePosition);
          
          if(newWaypoint.otherSideWaypoint != "")
          {
            this.$options.camera.rotation = new BABYLON.Vector3(BABYLON.Tools.ToRadians(newWaypoint.euler.x),BABYLON.Tools.ToRadians(newWaypoint.euler.y),0);
          }
        }
        else if (this.forceLandRotation)
        {
          this.$options.camera.rotation = new BABYLON.Vector3(BABYLON.Tools.ToRadians(newWaypoint.euler.x),BABYLON.Tools.ToRadians(newWaypoint.euler.y),0);
        }
        else if (newWaypoint.forceFaceDirection)
        {
           this.$options.camera.rotation = new BABYLON.Vector3(BABYLON.Tools.ToRadians(newWaypoint.euler.x),BABYLON.Tools.ToRadians(newWaypoint.euler.y),0);
        }

        this.SetForceLandRotation(false);
    },
    UpdateFloorMarkers()
    {
      if(this.activeTour != null)
        return;

      if(this.$options.floorMarkers != null)
      {
        for (let i = 0; i < this.$options.floorMarkers.length; i++) {
          this.$options.floorMarkers[i].dispose();
        }
      }
      this.$options.floorMarkers = [];

      var inst = this.GetBabPnl(this.babylonPanelIdentifier);

      let matchingWaypoints = this.processedWaypoints.filter(e => this.currentWaypoint.connectedWaypoints.includes(e.id));

      for (let i = 0; i < matchingWaypoints.length; i++) {
        const waypoint = matchingWaypoints[i];

        var box = BABYLON.MeshBuilder.CreatePlane("Clickable", {width : 1.707 * 0.03,height: 0.993 * 0.03},inst.scene);
        let dirVec = new BABYLON.Vector3(waypoint.pos.x - this.currentWaypoint.pos.x,0,waypoint.pos.z - this.currentWaypoint.pos.z).normalize();
        let angle = BABYLON.Vector3.GetAngleBetweenVectors(new BABYLON.Vector3(0,0,1), dirVec,  new BABYLON.Vector3(0,1,0));


        box.rotation = new BABYLON.Vector3(1.57079633,angle,0);
        var matBox = new BABYLON.StandardMaterial("matBox", inst.scene);
        matBox.diffuseTexture = new BABYLON.Texture("https://xpcwa.blob.core.windows.net/assets/WA%20Floor%20Arrow.png", inst.scene);
        matBox.diffuseTexture.hasAlpha = true;
        //matBox.emissiveTexture = new BABYLON.Texture("https://activstoredev.blob.core.windows.net/test/WA/WA%20Floor%20Arrow.png", inst.scene);
        matBox.emissiveColor = BABYLON.Color3.White();
        matBox.diffuseColor = new BABYLON.Color3(1.0, 0.1, 0.1);
        box.material = matBox;
        box.isPickable = true;
        box.position = new BABYLON.Vector3(this.currentWaypoint.pos.x,this.currentWaypoint.pos.y - 0.1,this.currentWaypoint.pos.z);


        box.translate(dirVec,0.26,BABYLON.Space.WORLD);
        

       
        this.$options.floorMarkers.push(box);
        box.actionManager = new BABYLON.ActionManager(inst.scene);
        box.actionManager.registerAction(
          new BABYLON.ExecuteCodeAction(
            BABYLON.ActionManager.OnPickTrigger,
            () => {this.OnClickFloorMarker(waypoint)}
          )
        );

        box.actionManager.registerAction(new BABYLON.SetValueAction(BABYLON.ActionManager.OnPointerOutTrigger, box.material, "emissiveColor", BABYLON.Color3.White()));
        box.actionManager.registerAction(new BABYLON.SetValueAction(BABYLON.ActionManager.OnPointerOverTrigger, box.material, "emissiveColor", new BABYLON.Color3(0,1,1)));
        box.actionManager.registerAction(new BABYLON.InterpolateValueAction(BABYLON.ActionManager.OnPointerOutTrigger, box, "scaling", new BABYLON.Vector3(1, 1, 1), 150));
        box.actionManager.registerAction(new BABYLON.InterpolateValueAction(BABYLON.ActionManager.OnPointerOverTrigger, box, "scaling", new BABYLON.Vector3(1.15, 1.15, 1.15), 150));


      }
    },
    OnClickFloorMarker(waypoint)
    {
      this.currentWaypoint = waypoint;

    },
    ProcessWaypoints()
    {
      this.processedWaypoints = [];
      
      for (let i = 0; i < this.waypoints.length; i++) {

        const wypn = this.waypoints[i];

        if(wypn.connectedWaypoints != null)
        {
          this.processedWaypoints.push(wypn);
          continue;
        }
          

        wypn.connectedWaypoints = [];
        let wypnPOS = new BABYLON.Vector3(
            wypn.pos.x, 
            wypn.pos.y, 
            wypn.pos.z);

        for(let w = 0; w < this.waypoints.length;w++)
        {
          const compareWypn = this.waypoints[w];
          if(compareWypn.id == wypn.id)
            continue;

          if(compareWypn.navigatable != null)
          {
            if(!compareWypn.navigatable)
            {
              continue;
            }
          }

          let compareWypnPOS = new BABYLON.Vector3(
            compareWypn.pos.x, 
            compareWypn.pos.y, 
            compareWypn.pos.z);

          let distance = BABYLON.Vector3.Distance(wypnPOS,compareWypnPOS);

          if(distance < this.waypointVisibilityDistance)
          {
            wypn.connectedWaypoints.push(compareWypn.id);
          }
        }

        this.processedWaypoints.push(wypn);
      }


  


      //this.LoadWaypointMarkers();

    },
    LoadWaypointMarkers()
    {
      //Clear old markers
      if(this.$options.panels != null)
      {
         for (let index = 0; index < this.$options.panels.length; index++) {
          this.$options.panels[index].dispose();
        }
      }
      this.$options.panels = [];

      if(this.$options.dummySpheres != null)
      {
        for (let index = 0; index < this.$options.dummySpheres.length; index++) {
          this.$options.dummySpheres[index].dispose();
        }
      }
      this.$options.dummySpheres = [];


      var inst = this.GetBabPnl(this.babylonPanelIdentifier);

      var sphereMat = new BABYLON.StandardMaterial("sphereMat", inst.scene);
      sphereMat.alpha = 0;

      for (let i = 0; i < this.waypoints.length; i++) {
        let sphere = BABYLON.Mesh.CreateSphere("Sphere_" + this.waypoints[i].id, 16, 0.5, inst.scene);
        // Move the sphere upward 1/2 its height
        sphere.position = new BABYLON.Vector3(
            this.waypoints[i].pos.x, 
            this.waypoints[i].pos.y, 
            this.waypoints[i].pos.z);

        sphere.isVisible = true;
        sphere.material = sphereMat;

        this.$options.dummySpheres.push(sphere);


        var wldpanel = new BABYLON.GUI.StackPanel();
        wldpanel.width = "150px";

        if(this.waypoints[i].name.length > 0)
        {
          wldpanel.height = "200px";
        }
        else
        {
          wldpanel.height = "50px";
        }
        this.$options.mainUi.addControl(wldpanel);
        wldpanel.linkWithMesh(sphere);
        wldpanel.isVisible  = true;

        this.$options.panels.push(wldpanel);

        if(this.waypoints[i].name.length > 0)
        {
          var label = new BABYLON.GUI.Rectangle("label");
          label.background = "black"
          label.height = "40px";
          label.alpha = 0.7;
          label.width = "150px";
          label.cornerRadius = 20;
          label.thickness = 0;
          label.top = "10%";
          label.parent = textblock;
          wldpanel.addControl(label);

          var textblock = new BABYLON.GUI.TextBlock();
          textblock.height = "50px";
          textblock.color = "white";
          textblock.fontSize = 16;
          textblock.text = this.waypoints[i].name;
          textblock.textWrapping = true;
          label.addControl(textblock); 
        }

      

        var wldbutton = BABYLON.GUI.Button.CreateImageOnlyButton("but", "https://activstorecore.blob.core.windows.net/test/hackimages/waypoint.png")
        wldbutton.width = "50px";
        wldbutton.height = "50px";
        wldbutton.cornerRadius = 20;
        wldbutton.thickness = 0;
        wldbutton.color = "black";

        
        wldbutton.onPointerUpObservable.add(() => {
            this.currentWaypoint = this.waypoints[i];
        });

        wldpanel.addControl(wldbutton);
      }
    },
    OnTapNextTourPoint()
    {
      this.SetForceLandRotation(true);
      this.GoNextTourPoint();
    },
    OnTapPrevTourPoint()
    {
      this.SetForceLandRotation(true);
      this.GoPrevTourPoint();
    }
  },
  watch: {
  
    showEndingMessage : {
      handler(newVal)
      {
        this.hasShownEndingMessage = true;
      }
    },
    //If set to active and we've not initalized, let's then do so
    isActive : {
      handler(newVal)
      {
        if(newVal)
        {
          this.Init();
        }
      }
    },
    waypoints : {
      handler(newVal)
      {

        this.firstWaypointLoad = true;
        this.ProcessWaypoints();  
      }
    },
    waypoint : {
      immediate : true,
      handler(newVal)
      {
        if(this.isInitalized && newVal != null)
        {
          this.$appInsights.trackEvent({name: "navigate_to_waypoint", properties: {id : newVal.id}});
          this.currentWaypoint = newVal;

          this.SetVideoGroupsToPlay(newVal.id);

          this.videoGroups.forEach(vidGrp => {

            if(vidGrp.waypoints.includes(newVal.id))
            {
              vidGrp.meshes.forEach(mesh => {

                mesh.material.alpha = 1;

              })
            }
            else
            {
              vidGrp.meshes.forEach(mesh => {

                mesh.material.alpha = 0;

              })

            }

          })
        }
      }
    },
    currentWaypoint : {
      immediate : true,
      handler (newVal)
      {

        

        if(this.isInitalized && newVal != null)
        {
          
          this.LoadWaypoint();
        }
      }
    }
    
  }
}
</script>
